import { useDataChange } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'selected',
    path: 'existing_employee_ids',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    // save the known employee ids so we can filter them from the select list
    change(data?.map(user => user.id))
  }
}
